{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Wheel",
  "alternateName": [
    "прокрутка кейсов в кс го", "cs wheel", "колесо фортуны кс",
    "барабан бонусов кс", "колесо удачи на скины кс", "wheel game cs"
  ],
  "description": "Колесо удачи – игра, где игрок вращает барабан и получает награды.",
  "url": "https://6cs.fail/ru/wheel"
}
